import { getColumnNameFromGeoColumn } from 'features/builder/state/builderSliceUtils'
import { formatPGRSSource } from '../../utils'

export const generateCreateTableFromQuery = ({ output, query, geoColumn }) => {
  const formattedOutput = formatPGRSSource(output)
  const geoColumnName = getColumnNameFromGeoColumn(geoColumn)
  return `
    CREATE TABLE ${formattedOutput} AS (
      ${query}
    );
    CREATE INDEX ON ${formattedOutput} USING GIST (${geoColumnName});
  `
}
